"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkmark = exports.CaretUp = exports.CaretDown = exports.OptionsContainer = exports.OptionWrapper = exports.SelectCaption = exports.SelectInput = exports.SelectWrapper = void 0;

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

exports.SelectWrapper = styled_components_1.default.div.attrs(function (props) {
  return {
    className: classnames_1.default(props.className, 'select')
  };
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 56px;\n  position: relative;\n"], ["\n  width: 100%;\n  height: 56px;\n  position: relative;\n"])));
var focusStyles = styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:focus {\n    outline: none;\n    ", ";\n  }\n\n  &:focus:not(:focus-visible) {\n    box-shadow: none;\n  }\n\n  &:focus-visible {\n    ", ";\n  }\n\n  &.is-expanded:focus {\n    outline: none;\n    ", ";\n  }\n\n  &.is-expanded:focus:not(:focus-visible) {\n    box-shadow: ", ";\n  }\n\n  &.is-expanded:focus-visible {\n    ", ";\n  }\n"], ["\n  &:focus {\n    outline: none;\n    ", ";\n  }\n\n  &:focus:not(:focus-visible) {\n    box-shadow: none;\n  }\n\n  &:focus-visible {\n    ", ";\n  }\n\n  &.is-expanded:focus {\n    outline: none;\n    ", ";\n  }\n\n  &.is-expanded:focus:not(:focus-visible) {\n    box-shadow: ", ";\n  }\n\n  &.is-expanded:focus-visible {\n    ", ";\n  }\n"])), function (props) {
  return props.theme.form.focus.light;
}, function (props) {
  return props.theme.form.focus.light;
}, function (props) {
  return props.theme.form.focus.light + ", " + props.theme.depth.elevation.v300;
}, function (props) {
  return props.theme.depth.elevation.v300;
}, function (props) {
  return props.theme.form.focus.light + ", " + props.theme.depth.elevation.v300;
});
var selectLabelStyles = styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  .select__label {\n    ", "\n    font-weight: ", ";\n    color: ", ";\n    text-transform: uppercase;\n  }\n\n  &.has-selection .select__label {\n    font-size: 10px;\n    line-height: 16px;\n    margin-top: -2px;\n  }\n\n  &.is-expanded.has-selection .select__label {\n    color: ", ";\n  }\n\n  &.is-disabled .select__label {\n    color: ", ";\n  }\n\n  &.has-error .select__label {\n    color: ", ";\n  }\n"], ["\n  .select__label {\n    ", "\n    font-weight: ", ";\n    color: ", ";\n    text-transform: uppercase;\n  }\n\n  &.has-selection .select__label {\n    font-size: 10px;\n    line-height: 16px;\n    margin-top: -2px;\n  }\n\n  &.is-expanded.has-selection .select__label {\n    color: ", ";\n  }\n\n  &.is-disabled .select__label {\n    color: ", ";\n  }\n\n  &.has-error .select__label {\n    color: ", ";\n  }\n"])), function (props) {
  return props.theme.font.label.v200;
}, function (props) {
  return props.theme.font.weight.v300;
}, function (props) {
  return props.theme.color.neutral.v500;
}, function (props) {
  return props.theme.color.primary.v200;
}, function (props) {
  return props.theme.color.neutral.v300;
}, function (props) {
  return props.theme.color.validation.error;
});
var selectInputStyles = styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  .select__inputValue {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: ", ";\n    text-transform: capitalize;\n    font-weight: ", ";\n  }\n"], ["\n  .select__inputValue {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: ", ";\n    text-transform: capitalize;\n    font-weight: ", ";\n  }\n"])), function (props) {
  return props.theme.color.primary.v600;
}, function (props) {
  return props.theme.font.weight.v200;
});
exports.SelectInput = styled_components_1.default.button.attrs(function (props) {
  return {
    className: classnames_1.default(props.className, 'select__input')
  };
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: inherit;\n  min-width: inherit;\n  border-radius: ", ";\n  height: 100%;\n  background: transparent;\n\n  border: 1px solid ", ";\n  font-size: 14px;\n  margin: 0;\n  color: ", ";\n\n  line-height: 19px;\n  letter-spacing: 0px;\n  text-align: left;\n  padding: 7px 14px;\n  cursor: pointer;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n  &.is-expanded {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n    border-color: transparent;\n    box-shadow: ", ";\n  }\n\n  &.is-disabled {\n    pointer-events: none;\n    cursor: not-allowed;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  width: inherit;\n  min-width: inherit;\n  border-radius: ", ";\n  height: 100%;\n  background: transparent;\n\n  border: 1px solid ", ";\n  font-size: 14px;\n  margin: 0;\n  color: ", ";\n\n  line-height: 19px;\n  letter-spacing: 0px;\n  text-align: left;\n  padding: 7px 14px;\n  cursor: pointer;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n  &.is-expanded {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n    border-color: transparent;\n    box-shadow: ", ";\n  }\n\n  &.is-disabled {\n    pointer-events: none;\n    cursor: not-allowed;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.theme.border.radius;
}, function (props) {
  return props.theme.color.neutral.v300;
}, function (props) {
  return props.theme.color.primary.v300;
}, function (props) {
  return props.theme.depth.elevation.v300;
}, focusStyles, selectLabelStyles, selectInputStyles);
exports.SelectCaption = styled_components_1.default.p(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n  margin-top: 4px;\n  ", "\n\n  &.has-error {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  margin-top: 4px;\n  ", "\n\n  &.has-error {\n    color: ", ";\n  }\n"])), function (props) {
  return props.theme.color.neutral.v500;
}, function (props) {
  return props.theme.font.detail.v100;
}, function (props) {
  return props.theme.color.validation.error;
});
var autocompleteStyles = styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
  return props.isAutocomplete ? "\n    &.is-selected,\n    &:hover {\n      background-color: " + props.theme.color.neutral.v200 + ";\n      color: " + props.theme.color.primary.v600 + ";\n    }\n  " : '';
});
exports.OptionWrapper = styled_components_1.default.div.attrs(function (props) {
  return {
    className: classnames_1.default(props.className, 'select__inputOptionWrapper')
  };
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  height: 48px;\n  padding: 8px;\n  margin: 0;\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 7px 14px;\n  cursor: pointer;\n  font-weight: ", ";\n\n  &.is-selected {\n    pointer-events: none;\n    color: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  ", "\n"], ["\n  height: 48px;\n  padding: 8px;\n  margin: 0;\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 7px 14px;\n  cursor: pointer;\n  font-weight: ", ";\n\n  &.is-selected {\n    pointer-events: none;\n    color: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  ", "\n"])), function (props) {
  return props.theme.color.primary.v600;
}, function (props) {
  return props.theme.font.weight.v200;
}, function (props) {
  return props.theme.color.neutral.v400;
}, function (props) {
  return props.theme.color.primary.v600;
}, function (props) {
  return props.theme.color.neutral.v100;
}, autocompleteStyles);
exports.OptionsContainer = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  height: fit-content;\n  max-height: 288px;\n  overflow-y: auto;\n  display: none;\n  position: absolute;\n  top: 55px;\n  z-index: 10;\n  background-color: ", ";\n  border-bottom-right-radius: ", ";\n  border-bottom-left-radius: ", ";\n\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: 0px;\n  text-align: left;\n\n  &.is-expanded {\n    display: block;\n    border-color: transparent;\n    border-top-color: ", ";\n    box-shadow: ", ";\n  }\n\n  ", "\n"], ["\n  border: 1px solid ", ";\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  height: fit-content;\n  max-height: 288px;\n  overflow-y: auto;\n  display: none;\n  position: absolute;\n  top: 55px;\n  z-index: 10;\n  background-color: ", ";\n  border-bottom-right-radius: ", ";\n  border-bottom-left-radius: ", ";\n\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: 0px;\n  text-align: left;\n\n  &.is-expanded {\n    display: block;\n    border-color: transparent;\n    border-top-color: ", ";\n    box-shadow: ", ";\n  }\n\n  ", "\n"])), function (props) {
  return props.theme.color.neutral.v300;
}, function (props) {
  return props.theme.color.neutral.v100;
}, function (props) {
  return props.theme.border.radius;
}, function (props) {
  return props.theme.border.radius;
}, function (props) {
  return props.theme.color.neutral.v300;
}, function (props) {
  return props.theme.depth.elevation.v300;
}, focusStyles);
var Path = styled_components_1.default('path')(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  fill: ", ";\n  &.is-disabled {\n    fill: ", ";\n  }\n"], ["\n  fill: ", ";\n  &.is-disabled {\n    fill: ", ";\n  }\n"])), function (props) {
  return props.theme.color.primary.v200;
}, function (props) {
  return props.theme.color.neutral.v300;
});

var CaretDown = function CaretDown(_a) {
  var disabled = _a.disabled;
  return react_1.default.createElement("svg", {
    width: "9",
    height: "5",
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, react_1.default.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5.45614L0 0.543861H9L4.5 5.45614Z",
    className: disabled && 'is-disabled'
  }));
};

exports.CaretDown = CaretDown;

var CaretUp = function CaretUp() {
  return react_1.default.createElement("svg", {
    width: "9",
    height: "5",
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, react_1.default.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 0L0 5H9L4.5 0Z"
  }));
};

exports.CaretUp = CaretUp;

var Checkmark = function Checkmark() {
  return react_1.default.createElement("svg", {
    width: "9",
    height: "7",
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, react_1.default.createElement(Path, {
    d: "M3.10104 7L0.272375 4.27132C-0.0907918 3.90632 -0.0907918 3.34196 0.272375 2.97695C0.444094 2.80521 0.684592 2.70769 0.9364 2.70769C1.18821 2.70769 1.42871 2.80521 1.60042 2.97695L3.10104 4.43224L7.40032 0.269263C7.57204 0.0975222 7.81254 0 8.06435 0C8.31615 0 8.55665 0.0975222 8.72837 0.269263C9.09054 0.631941 9.09054 1.19396 8.72837 1.55664L3.10104 7Z"
  }));
};

exports.Checkmark = Checkmark;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;